export default {
    label_task:{
        en:"Territory Market Size Setup",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"Setup New Territory Market Size",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Territory Market Size",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Territory Market Size",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_market_size_total :{
        en:"Total Market Size",
        bn:'ব্যবহারকারীরা'
    },
}